import { CONFIG } from 'src/global-config';

import { Betingelser } from './betingelser';

// ----------------------------------------------------------------------

const metadata = { title: `Betingelser - ${CONFIG.appName}` };

export default function Page() {
  return (
    <>
      <title>{metadata.title}</title>

      <Betingelser />
    </>
  );
}
